export const ErrorMessages: { [key: number]: string } = {
  401: 'User invalid credentials',
  422: 'Email must be an email',
};
